module.exports = __webpack_public_path__ + "img/wxCode.484536df.png";